import React from 'react';
import './mainBanner.css';

const MainBanner = ({ image, color, text }) => {
    const isYellowBackground = color === '#FFCD00';

    return (
        <div className='main-banner-container'>
            <div
                className="banner-container"
                style={{
                    backgroundImage: `url(${image})`,
                }}
            ></div>
            <div
                className={`banner-text ${isYellowBackground ? 'yellow-bg' : ''}`}
                style={{
                    backgroundColor: color,
                }}
            >
                <h3 dangerouslySetInnerHTML={{ __html: text }}></h3>
            </div>
        </div>
    );
};

export default MainBanner;
